import smoothscroll from 'smoothscroll-polyfill';

// Polyfill for window.scrollTo
if (typeof window !== 'undefined') {
  smoothscroll.polyfill();
}

export const getRect = selector => {
  const target = document.querySelector(selector);
  return target.getBoundingClientRect();
};

export const getOffset = (selector, newTop) => {
  if (selector) {
    const { top, height } = getRect(selector);

    if (top < newTop) {
      return height;
    }
  }

  return 0;
};

export default (
  selector,
  { offset = 0, collapsibleSelector, headerSelector = 'header.header' } = {}
) => {
  const target = document.querySelector(selector);
  const { top } = target.getBoundingClientRect();

  const { height: headerOffset } = getRect(headerSelector);

  // Offset against any collapsing selectors to ensure scroll doesn't miss
  const collapsibleOffset = getOffset(collapsibleSelector, top);

  window.scrollTo({
    top: top + window.pageYOffset - (offset + headerOffset + collapsibleOffset),
    behavior: 'smooth'
  });
};



// WEBPACK FOOTER //
// ./src/client/js/view/utils/scrollTo.js